import { PlayCircleIcon } from './PlayCircleIcon';

/**
 * author: Google
 * id 79F68E60-010F-4A8E-8E30-06CB64A5DBF6
 * name play-circle
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/play-circle.svg
 * tags
 */
export const PlayCircleFilledIcon = PlayCircleIcon;
export default PlayCircleFilledIcon